import { render, staticRenderFns } from "./SumupDetailTab.vue?vue&type=template&id=0320212c&"
import script from "./SumupDetailTab.vue?vue&type=script&lang=ts&"
export * from "./SumupDetailTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports